import { useCallback, useState } from "react";

import { FilterQueryOptions, TreePicklistItemResponse } from "../../TreePicklistItemProvider";
import { getCandyHub } from "../../../../../../Forms/Sentry/InitializeSentry";

import { useTryToRequestNodes } from "./useTryToRequestNodes";
import { CommonTreeNodeProps } from "./ITreeNodeProps";

type UseNodesResponse = (params: UseNodesResponseParams) => NodesResponse;

interface UseNodesResponseParams {
    props: CommonTreeNodeProps;
    useRequestNodesEffect: UseRequestNodesEffect;
    onLoadingError: () => void;
}

export type UseRequestNodesEffect = (requestNodesCallback: RequestNodesCallback) => void;

export type RequestNodesCallback = (filterQueryOptions: FilterQueryOptions, aborted: boolean) => Promise<void>;

export interface NodesResponse {
    nodeList: TreePicklistItemResponse[];
    loading: boolean;
}

export const useNodesResponse: UseNodesResponse = ({ props, useRequestNodesEffect, onLoadingError }) => {
    const [nodeList, setNodeList] = useState<TreePicklistItemResponse[]>([]);
    const [loading, setLoading] = useState(false);

    const tryToRequestNodes = useTryToRequestNodes(props);

    const requestNodesCallback: RequestNodesCallback = useCallback(async (filterQueryOptions, aborted) => {
        try {
            setLoading(true);
            const children = await tryToRequestNodes(filterQueryOptions);
            if (aborted) {
                return;
            }
            setNodeList(prev => prev.concat(children));
            setLoading(false);
        } catch (error) {
            setLoading(false);
            onLoadingError();
            getCandyHub().captureException(error);
        }
    }, []);

    useRequestNodesEffect(requestNodesCallback);

    return { nodeList: nodeList, loading: loading };
};
